import styled from 'styled-components';
import { Button } from '@grupoboticario/flora-react';

export const ButtonSpaceG = styled(Button)`
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

export const Label = styled.div`
  position: relative;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0px 7px;
  border-left: 0.5px solid ${({ theme }) => theme.colors.main};
  margin-bottom: 17px;
  color: #000000;
  span {
    position: absolute;
    top: 6px;
    right: 0;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 9px;
    font-style: normal;
    font-weight: bold;
    line-height: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    span {
      position: relative;
      top: 0;
      color: ${({ theme }) => theme.colors.error};
      @media (max-width: 570px) {
        display: inline-block;
      }
    }
    @media (max-width: 570px) {
      position: relative;
      display: block;
      top: 0;
      right: 0;
    }
  }
  &.only-warning {
    border-left: 0;
    min-height: 18px;
    margin-bottom: 11px;
  }
`;

export const RowInput = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  @media (max-width: 580px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const ColInput = styled.div`
  flex: 1;
  margin-bottom: 12px;
`;

export const CardInfo = styled.div`
  width: 100%;
  max-width: 570px;
  background: #ffffff;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  padding: 0 13px 13px;
  margin-bottom: 18px;
`;

export const CardInfoTitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  padding: 13px 9px;
  color: ${({ theme }) => theme.colors.main};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
`;

export const CardInfoFieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 13px 9px;
  gap: 6px;
  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const CardInfoField = styled.div<{ flex: number }>`
  flex: ${props => (props.flex ? props.flex : 1)};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  @media (max-width: 570px) {
    flex: 1;
    margin-bottom: 6px;
  }
  & span {
    display: block;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #9c9c9c;
  }
`;

export const GenericCardWrapper = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
`;
